{
  "acceptedFileFormats": "Γίνονται δεκτά μόνο αρχεία .docx, .pdf, .txt.",
  "actionCompetenceGroup": "Ομάδα Ικανοτήτων Ενέργειας",
  "actionDeadline": "Προθεσμία Ενέργειας",
  "actionDescription": "Περιγραφή Ενέργειας",
  "actionDuration": "Διάρκεια Ενέργειας",
  "actionEarliestStart": "Νωρίτερη Έναρξη Ενέργειας",
  "actionName": "Όνομα Ενέργειας",
  "actions": "Ενέργειες",
  "actionsAndProjects": "Ενέργειες & Έργα",
  "actionsColon": "Ενέργειες: ",
  "actionsPerformerConstraints": "Περιορισμοί Εκτελεστή Ενεργειών",
  "add": "Προσθήκη",
  "addAdmin": "Προσθήκη Διαχειριστή",
  "addAdminTitle": "Προσθήκη Διαχειριστή",
  "addAnalyses": "Προσθήκη αναλύσεων",
  "addAnalysis": "Προσθήκη Ανάλυσης",
  "addAnalysisGroup": "Προσθήκη ομάδας ανάλυσης",
  "addChatbot": "Προσθήκη chatbot",
  "addCompetenceGroup": "Προσθήκη Ομάδας Ικανοτήτων",
  "addConstraint": "Προσθήκη περιορισμού",
  "addGreyTask": "Προσθήκη Γκρι Εργασίας",
  "addInstrument": "Προσθήκη Οργάνου",
  "addItemPlaceholder": "Προσθήκη {{item}}...",
  "addLocation": "Προσθήκη τοποθεσίας",
  "addMaintenance": "Προσθήκη συντήρησης",
  "addMember": "Προσθήκη μέλους",
  "addNewBundle": "Προσθήκη Νέου Πακέτου",
  "addNewMaintenanceFor": "Προσθήκη νέας συντήρησης για {{assetName}}",
  "addNewTask": "Προσθήκη νέας εργασίας",
  "addOffsite": "Προσθήκη ΕΚΤΟΣ ΕΓΚΑΤΑΣΤΑΣΗΣ",
  "addProjectGroup": "Προσθήκη ομάδας έργων",
  "addProjectTemplate": "Προσθήκη Προτύπου Έργου",
  "addRepository": "Προσθήκη αποθετηρίου",
  "addRow": "Προσθήκη Γραμμής",
  "addSample": "Προσθήκη δείγματος",
  "addSamples": "Προσθήκη δειγμάτων",
  "addTeam": "Προσθήκη ομάδας",
  "additionalInformation": "Πρόσθετες Πληροφορίες",
  "administrators": "Διαχειριστές",
  "advanced": "Για προχωρημένους",
  "allFilesProcessed": "Όλα τα αρχεία που ανέβηκαν έχουν επεξεργαστεί",
  "allowMembersMoveOthersOperationalTasks": "Να επιτρέπεται στα μέλη να μετακινούν επιχειρησιακές εργασίες άλλων",
  "allowedCompetenceGroups": "Επιτρεπόμενες Ομάδες Ικανοτήτων",
  "allowedInstruments": "Επιτρεπόμενα όργανα",
  "amountOfSamples": "Αριθμός δειγμάτων: {{count}}",
  "analyses": "Αναλύσεις",
  "analysesRelatedTo": "Αναλύσεις που σχετίζονται με {{product}}",
  "analysis": "Ανάλυση",
  "analysisAndSampleDone": "Η ανάλυση και το δείγμα έχουν ολοκληρωθεί",
  "analysisDefinition": "ορισμός ανάλυσης",
  "analysisDesignTool": "Εργαλείο Σχεδιασμού Ανάλυσης",
  "analysisDone": "Η ανάλυση έχει ολοκληρωθεί",
  "analysisDraft": "ΠΡΟΣΧΕΔΙΟ Ανάλυσης",
  "analysisGroup": "Ομάδα ανάλυσης",
  "analysisGroupName": "Όνομα Ομάδας Ανάλυσης",
  "analysisIsFlagged": "Η ανάλυση έχει επισημανθεί",
  "analysisMustContainTaskDefinition": "Η ανάλυση πρέπει να περιέχει ορισμό εργασίας",
  "analysisName": "Όνομα Ανάλυσης",
  "analysisNameMustBeUnique": "Το Όνομα Ανάλυσης πρέπει να είναι μοναδικό",
  "analysisNotPlanned": "Αυτή η ανάλυση δεν είναι προγραμματισμένη",
  "analysisPlanned": "Η ανάλυση είναι προγραμματισμένη",
  "analysisTaskBundle": "Πακέτο Εργασίας Ανάλυσης {{index}}",
  "cdmoTargetedBundle": "Ομαδοποίηση εργασιών κατά όνομα ανάλυσης",
  "analysisTaskTimePerformerSamples": "Εργασία Ανάλυσης - Χρόνος, Εκτελεστής, Αριθμός Δειγμάτων",
  "analysisTasks": "εργασίες ανάλυσης",
  "analysisTasksToBundle": "Εργασίες Ανάλυσης για Ομαδοποίηση",
  "analysisTimePercentage": "Ποσοστό χρόνου ανάλυσης ως προς τον συνολικό χρόνο (A2T)",
  "anywhere": "Οπουδήποτε",
  "apiToken": "Token API",
  "archiveMember": "Αρχειοθέτηση Μέλους",
  "archived": "αρχειοθετημένο",
  "areYouSureConnection": "Είστε σίγουροι ότι θέλετε αυτή τη σύνδεση;",
  "areYouSureConnectionMode": "Είστε σίγουροι ότι θέλετε να μεταβείτε στη λειτουργία \"με σύνδεση\"; Αυτό θα αφαιρέσει όλες τις τρέχουσες συνδέσεις",
  "areYouSureDeleteAdmin": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον διαχειριστή;",
  "areYouSureDiscardSimulation": "Είστε σίγουροι ότι θέλετε να απορρίψετε τις αλλαγές που έγιναν σε λειτουργία προσομοίωσης;",
  "areYouSurePublishSimulation": "Είστε σίγουροι ότι θέλετε να δημοσιεύσετε τις αλλαγές που έγιναν σε λειτουργία προσομοίωσης;",
  "areYouSureReset": "Είστε σίγουροι ότι θέλετε να γίνει επαναφορά; Αυτό θα αφαιρέσει όλους τους κόμβους.",
  "areYouSureUnplanAllFutureActions": "Είστε σίγουροι ότι θέλετε να αποπρογραμματίσετε όλες τις μελλοντικές ενέργειες σε αυτό το έργο;",
  "areYouSureWantToExit": "Είστε σίγουροι ότι θέλετε να βγείτε;",
  "arrival": "Άφιξη",
  "assetAddedOrRemoved": "Ένα στοιχείο έχει προστεθεί ή αφαιρεθεί",
  "assetRequirementsForAsset": "Απαιτήσεις Στοιχείου για το Στοιχείο {{index}}",
  "assets": "Στοιχεία",
  "atLeast1LowercaseLetter": "τουλάχιστον 1 πεζό γράμμα",
  "atLeast1Number": "τουλάχιστον 1 αριθμός",
  "atLeast1UppercaseLetter": "τουλάχιστον 1 κεφαλαίο γράμμα",
  "atLeast8Characters": "τουλάχιστον 8 χαρακτήρες",
  "automaticImportConversionSheet": "Αυτόματο Φύλλο Μετατροπής Εισαγωγής {{type}}",
  "automaticSheetConfiguration": "Αυτόματη Διαμόρφωση Φύλλου",
  "availability": "Διαθεσιμότητα",
  "availableTimeOneWeek": "Διαθέσιμος χρόνος μιας εβδομάδας: ",
  "avgAnalysisDuration": "Μέση διάρκεια ανάλυσης: ",
  "avgSampleBatchInterval": "Μέσο διάστημα παρτίδας δειγμάτων: ",
  "avgSamplesAllocated": "Μέσος αριθμός κατανεμημένων δειγμάτων: ",
  "backlog": "Εκκρεμότητες",
  "booked": "Δεσμευμένο",
  "bookedBy": "Δεσμεύτηκε από",
  "byCompetenceGroup": "Ανά Ομάδα Ικανοτήτων",
  "byDeadline": "Ανά Προθεσμία",
  "byGroup": "Ανά Ομάδα",
  "byText": "Ανά Κείμενο",
  "canBePerformedAnywhere": "Μπορεί να εκτελεστεί οπουδήποτε",
  "canOnlyBePerformedOnSite": "Μπορεί να εκτελεστεί μόνο επί τόπου",
  "cancel": "Ακύρωση",
  "cancelChanges": "Ακύρωση Αλλαγών",
  "cannotUnlockStartedTasks": "Δεν μπορείτε να ξεκλειδώσετε αυτό καθώς μία ή περισσότερες εργασίες είναι σε εξέλιξη/παύση/ολοκλήρωση",
  "changeLogs": "Αρχεία Αλλαγών",
  "changesHaveBeenMade": "Έχουν γίνει αλλαγές, επαναφορτώστε για νέα δεδομένα",
  "chatbotGreeting": "Γεια σας, είμαι το AI CHATBOT σας, εξειδικευμένο στην τεκμηρίωση βοήθειας του Plannertech & Librarian, και στα αποθετήρια δεδομένων που έχετε εισάγει.\nΜπορείτε επίσης πάντα να επικοινωνήσετε με την Ανθρώπινη Υποστήριξή μας στο pt@arnvind.com από 9 έως 16 CET.\nΠώς μπορώ να σας βοηθήσω; :-)",
  "chatbotName": "Όνομα Chatbot",
  "chatbotPlaceholder": "Γράψτε μια σύντομη περιγραφή για το πώς πρέπει να συμπεριφέρεται το chatbot.",
  "chatbots": "Chatbots",
  "chattingWith": "Συνομιλία με {{name}}",
  "chooseAction": "Επιλογή Ενέργειας",
  "chooseTask": "Επιλογή Εργασίας",
  "chooseWhatToAdd": "Επιλέξτε τι να προσθέσετε",
  "cleanUp": "Εκκαθάριση",
  "clear": "Εκκαθάριση",
  "clearConversation": "Εκκαθάριση συνομιλίας",
  "clearDates": "Εκκαθάριση Ημερομηνιών",
  "clearTable": "Εκκαθάριση Πίνακα",
  "clickToSelectOtherFiles": "Κάντε κλικ για να επιλέξετε άλλα αρχεία",
  "close": "Κλείσιμο",
  "closeMessage": "κλείσιμο μηνύματος",
  "closePanel": "Κλείσιμο πλαισίου",
  "collaborator": "Συνεργάτης",
  "collaborators": "Συνεργάτες",
  "domain": "Τομέας",
  "color": "Χρώμα",
  "columnName": "Όνομα Στήλης",
  "companyWideChatbot": "Chatbot για όλη την εταιρεία",
  "competenceAndInstrumentConstraints": "Περιορισμοί Ικανοτήτων και Οργάνων",
  "competenceGroup": "Ομάδα Ικανοτήτων",
  "competenceGroupNameExists": "Υπάρχει ήδη μια ομάδα ικανοτήτων με αυτό το όνομα",
  "competenceGroups": "Ομάδες Ικανοτήτων",
  "competenceGroupsColon": "Ομάδες Ικανοτήτων: ",
  "configuration": "Διαμόρφωση",
  "confirm": "Επιβεβαίωση",
  "confirmArchivalOfMember": "Επιβεβαίωση αρχειοθέτησης μέλους: {{initials}}",
  "confirmClearTable": "Είστε σίγουροι ότι θέλετε να εκκαθαρίσετε τον πίνακα;",
  "confirmDeleteAllData": "Επιβεβαιώνοντας αυτό θα διαγραφούν όλα τα δεδομένα {{type}}. Δεν υπάρχει επιστροφή, ακόμα και με τη Λειτουργία Προσομοίωσης.",
  "confirmDeleteAllUnplannedProjects": "Επιβεβαιώνοντας αυτό θα διαγραφούν όλα τα έργα που δεν έχουν ενέργειες στο πλάνο",
  "confirmDeleteAllUnplannedSamples": "Επιβεβαιώνοντας αυτό θα διαγραφούν όλα τα δείγματα που δεν έχουν ενέργειες στο πλάνο",
  "confirmDeleteCompetenceGroup": "Επιβεβαίωση διαγραφής ομάδας ικανοτήτων:",
  "confirmDeleteInstrument": "Είστε σίγουροι ότι θέλετε να διαγράψετε το όργανο: {{name}};",
  "confirmDeleteMaintenance": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συντήρηση;",
  "confirmDeleteSample": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το μη προγραμματισμένο δείγμα;",
  "confirmDeleteSampleInfo": "Επιβεβαιώνοντας αυτό θα διαγραφεί οριστικά το επιλεγμένο δείγμα",
  "confirmDeletion": "Επιβεβαίωση διαγραφής",
  "confirmFailSamples": "Είστε σίγουροι ότι θέλετε να αποτύχουν τα επιλεγμένα δείγματα;",
  "confirmFailSamplesInfo": "Επιβεβαιώνοντας αυτό τα επιλεγμένα δείγματα θα αποτύχουν. Ένα αντίγραφο θα τοποθετηθεί στο μενού μη προγραμματισμένων αναλύσεων",
  "confirmFailSamplesQuestion": "Είστε σίγουροι ότι θέλετε να αποτύχουν τα επιλεγμένα δείγματα;",
  "confirmShowPlannedSamplesInfo": "Επιβεβαιώνοντας αυτό θα εμφανιστούν τα προγραμματισμένα δείγματα",
  "confirmShowPlannedSamplesQuestion": "Είστε σίγουροι ότι θέλετε να εμφανίσετε τα προγραμματισμένα δείγματα;",
  "confirmSortByTime": "Είστε σίγουροι ότι θέλετε να ταξινομήσετε κατά χρόνο",
  "confirmUnplanAllFutureActions": "Είστε σίγουροι ότι θέλετε να αποπρογραμματίσετε όλες τις μελλοντικές ενέργειες σε αυτό το έργο;",
  "confirmUnplanAllQuestion": "Είστε σίγουροι ότι θέλετε να αποπρογραμματίσετε όλα τα {{itemType}};",
  "confirmUnplanSamplesInfo": "Επιβεβαιώνοντας αυτό θα αποπρογραμματιστούν τα επιλεγμένα δείγματα. Θα τοποθετηθούν στο μενού μη προγραμματισμένων αναλύσεων",
  "confirmUnplanSamplesQuestion": "Είστε σίγουροι ότι θέλετε να αποπρογραμματίσετε τα επιλεγμένα δείγματα;",
  "connectionCalculatedInWorkdays": "Σύνδεση υπολογισμένη σε εργάσιμες ημέρες",
  "connectionCount": "Αριθμός Συνδέσεων",
  "connections": "Συνδέσεις",
  "connectionsAdvancedWarning": "(Η χρήση συνδέσεων με προθεσμία ή νωρίτερη έναρξη σε ενέργειες είναι για προχωρημένους χρήστες)",
  "connectionsPerformersOnly": "Οι συνδέσεις αφορούν μόνο εκτελεστές — δεν επηρεάζει την κατανομή στοιχείων",
  "contactArnvindSupport": "Παρακαλώ επικοινωνήστε με την υποστήριξη Arnvind στο pt@arnvind.com",
  "conversionSheet": "Φύλλο Μετατροπής",
  "copyToClipboard": "αντιγραφή στο πρόχειρο",
  "country": "Χώρα",
  "create": "Δημιουργία",
  "createANewColumn": "Δημιουργία νέας Στήλης",
  "createAction": "Δημιουργία Ενέργειας",
  "createChatbot": "Δημιουργία chatbot",
  "createEditChatbots": "Δημιουργία/επεξεργασία chatbots",
  "createEditRepositories": "Δημιουργία/επεξεργασία αποθετηρίων",
  "createNewColumn": "Δημιουργία νέας Στήλης",
  "createNewProject": "Δημιουργία Νέου Έργου",
  "createSingleAction": "Δημιουργία Μεμονωμένης Ενέργειας",
  "createStage": "Δημιουργία Σταδίου",
  "createStandardAction": "Δημιουργία Τυπικής Ενέργειας",
  "currentlyProcessingRepository": "Επεξεργασία αυτού του αποθετηρίου σε εξέλιξη",
  "daily": "Καθημερινά",
  "date": "Ημερομηνία",
  "dateUnavailable": "Μη Διαθέσιμη Ημερομηνία",
  "day": "ημέρα",
  "dayS": "ημέρα(ες)",
  "days": "ημέρα(ες)",
  "daysBeforeExpirationWarning": "Ημέρες πριν τη λήξη για εμφάνιση προειδοποίησης",
  "daysBetweenRecurrences": "Ημέρες Μεταξύ Επαναλήψεων",
  "deadline": "Προθεσμία",
  "deadlineColon": "Προθεσμία: ",
  "deadlineDate": "Ημερομηνία προθεσμίας",
  "deadlineMustBeLaterThanEarliestStart": "Η προθεσμία πρέπει να είναι μεταγενέστερη ή ίση με τη νωρίτερη έναρξη",
  "deadlineTime": "Ώρα Προθεσμίας",
  "defaultChatbot": "Προεπιλεγμένο chatbot",
  "delete": "Διαγραφή",
  "deleteAllTypeTestData": "Διαγραφή όλων των δεδομένων δοκιμής {{type}}",
  "deleteAllUnplannedProjects": "Διαγραφή όλων των Μη Προγραμματισμένων Έργων",
  "deleteAllUnplannedSamples": "Διαγραφή όλων των Μη Προγραμματισμένων Δειγμάτων",
  "deleteColumn": "Διαγραφή Στήλης",
  "deleteCompetenceGroup": "Διαγραφή Ομάδας Ικανοτήτων",
  "deleteCompetenceGroupWarning": "Η διαγραφή αυτής θα αφήσει εργασίες στις παρακάτω αναλύσεις χωρίς Ομάδα Ικανοτήτων. Βεβαιωθείτε για αντικατάσταση πριν από την αφαίρεση.",
  "deleteConstraint": "Διαγραφή περιορισμού",
  "deleteData": "Διαγραφή Δεδομένων",
  "deleteInstrument": "Διαγραφή Οργάνου",
  "deleteInstrumentWarning": "Θα διαγραφεί επίσης για άλλες ομάδες σε αυτή την τοποθεσία.",
  "deleteProjects": "Διαγραφή Έργων",
  "deleteSample": "Διαγραφή Δείγματος",
  "deleteSamples": "Διαγραφή Δειγμάτων",
  "deleteThisRow": "Διαγραφή αυτής της γραμμής",
  "description": "Περιγραφή",
  "designTool": "Εργαλείο Σχεδιασμού",
  "done": "Ολοκληρώθηκε",
  "draft": "προσχέδιο",
  "dragAndDropFiles": "Σύρετε και αποθέστε αρχεία εδώ, ή κάντε κλικ για να επιλέξετε αρχεία",
  "dragAndDropFolders": "Σύρετε και αποθέστε φακέλους εδώ, ή κάντε κλικ για να επιλέξετε συγκεκριμένα αρχεία",
  "dropFilesHere": "Αποθέστε αρχεία εδώ",
  "dropFoldersHere": "Αποθέστε τους φακέλους εδώ...",
  "duplicate": "Αντιγραφή",
  "durationHHMM": "Διάρκεια (ΩΩ:ΛΛ)",
  "earliestStart": "Νωρίτερη Έναρξη",
  "edit": "Επεξεργασία",
  "editAction": "Επεξεργασία Ενέργειας",
  "editAdmin": "Επεξεργασία Διαχειριστή",
  "editAnalysisGroup": "Επεξεργασία ομάδας ανάλυσης",
  "editAnalysisTask": "Επεξεργασία Εργασίας Ανάλυσης",
  "editChatbot": "Επεξεργασία chatbot",
  "editCompetenceGroup": "Επεξεργασία Ομάδας Ικανοτήτων",
  "editConnectionFromTo": "Επεξεργασία σύνδεσης από {{from}} σε {{to}}",
  "editConversation": "Επεξεργασία Συνομιλίας",
  "editGroup": "Επεξεργασία ομάδας",
  "editInstrument": "Επεξεργασία Οργάνου",
  "editItem": "Επεξεργασία {{item}}",
  "editLocationName": "Επεξεργασία ονόματος τοποθεσίας",
  "editMaintenanceFor": "Επεξεργασία {{name}} για {{assetName}}",
  "editMember": "Επεξεργασία μέλους",
  "editOffsite": "Επεξεργασία ΕΚΤΟΣ ΕΓΚΑΤΑΣΤΑΣΗΣ",
  "editProject": "Επεξεργασία Έργου",
  "editProjectGroup": "Επεξεργασία ομάδας έργων",
  "editProjectTemplate": "Επεξεργασία Προτύπου Έργου",
  "editProjectTemplateDraft": "Επεξεργασία ΠΡΟΣΧΕΔΙΟΥ Προτύπου Έργου",
  "editRepository": "Επεξεργασία αποθετηρίου",
  "editSampleName": "Επεξεργασία δείγματος: {{name}}",
  "editSheet": "Επεξεργασία Φύλλου {{name}}",
  "editStandardAction": "Επεξεργασία Τυπικής Ενέργειας",
  "editTask": "Επεξεργασία εργασίας",
  "editTeam": "Επεξεργασία ομάδας",
  "edited": "Επεξεργάστηκε",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "Το email δεν μπορεί να περιέχει '..'",
  "emailLabel": "Email",
  "endDate": "Ημερομηνία λήξης",
  "enterSimulationMode": "Είσοδος σε Λειτουργία Προσομοίωσης",
  "errors": "Σφάλματα",
  "errorsProcessingRepository": "Παρουσιάστηκαν σφάλματα κατά την επεξεργασία αυτού του αποθετηρίου",
  "estimatedWorkloadOneWeek": "Εκτιμώμενος φόρτος εργασίας μιας εβδομάδας: ",
  "exclusive": "Αποκλειστικό",
  "exclusiveSampleIndicator": "* Υποδηλώνει αποκλειστικό δείγμα",
  "exitSimulation": "ΕΞΟΔΟΣ ΠΡΟΣΟΜΟΙΩΣΗΣ",
  "exitSimulationMode": "Έξοδος από λειτουργία προσομοίωσης",
  "expand": "Ανάπτυξη",
  "exportToExcel": "Εξαγωγή σε Excel",
  "fail": "Αποτυχία",
  "failSample": "Αποτυχία Δείγματος",
  "failSelected": "Αποτυχία Επιλεγμένων",
  "failedLoading": "Αποτυχία φόρτωσης: {{members}}",
  "failedToCreateMaintenance": "Αποτυχία δημιουργίας συντήρησης \"{{name}}\"",
  "failedToDeleteMaintenance": "Αποτυχία διαγραφής συντήρησης \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Αποτυχία επισήμανσης συντήρησης \"{{name}}\" ως ολοκληρωμένης",
  "failedToUpdateMaintenance": "Αποτυχία ενημέρωσης συντήρησης \"{{name}}\"",
  "failedUploads": "Αποτυχημένες Αναρτήσεις",
  "fileUpload": "Ανάρτηση Αρχείου",
  "fileUploadError": "Παρουσιάστηκε σφάλμα κατά την ανάρτηση του αρχείου",
  "filenameLabel": "Όνομα αρχείου: ",
  "filesUploadedSuccessfully": "Τα αρχεία αναρτήθηκαν επιτυχώς",
  "fillIn": "Συμπλήρωση",
  "fillInIgnoreOverbooking": "Συμπλήρωση Αγνοώντας Υπέρ-κράτηση",
  "filter": "Φιλτράρισμα",
  "filterByName": "Φιλτράρισμα κατά Όνομα",
  "filterBySampleName": "Φιλτράρισμα κατά Όνομα Δείγματος",
  "filterBySampleProductName": "Φιλτράρισμα κατά Όνομα Δείγματος/Προϊόντος",
  "filterByText": "Φιλτράρισμα κατά Κείμενο",
  "finished": "Ολοκληρώθηκε",
  "flag": "Επισήμανση",
  "flagSample": "Επισήμανση Δείγματος",
  "followingErrorsWhileImporting": "Τα παρακάτω σφάλματα κατά την εισαγωγή:",
  "free": "Ελεύθερο",
  "from": "Από",
  "fromDate": "Από ημερομηνία",
  "fromTime": "Από ώρα (ΩΩ:ΛΛ)",
  "fromTimeHH": "Από ώρα (ΩΩ)",
  "fromTimeHHMM": "Από ώρα (ΩΩ:ΛΛ)",
  "futureAnalysisTaskCantBe": "Μια μελλοντική εργασία ανάλυσης δεν μπορεί να είναι {{state}}",
  "generate": "Δημιουργία",
  "globalChatbot": "Καθολικό chatbot",
  "goBack": "Πίσω",
  "goBackToChat": "Επιστροφή στη συνομιλία",
  "greyTaskTimePercentage": "Ποσοστό χρόνου γκρι εργασίας ως προς τον συνολικό χρόνο (G2T)",
  "groupMembers": "Μέλη Ομάδας",
  "groupName": "Όνομα Ομάδας",
  "help": "Βοήθεια",
  "helpBackToApp": "Επιστροφή στην εφαρμογή",
  "helpHome": "Αρχική βοήθειας",
  "helpPageNotFound": "Η σελίδα βοήθειας δεν βρέθηκε",
  "helpSearch": "Αναζήτηση βοήθειας",
  "helpAppTitle": "Βοήθεια Plannertech",
  "hidden": "Κρυφό",
  "hideMore": "Απόκρυψη περισσότερων",
  "highestPriority": "Το 1 είναι η υψηλότερη προτεραιότητα",
  "history": "Ιστορικό",
  "home": "Αρχική",
  "hour": "ώρα",
  "iCalendarOutlookIntegration": "Ενσωμάτωση iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Αγνόηση Όλων των Γκρι Εργασιών",
  "ignoredByIap": "Αγνοείται από το IAP",
  "includingToday": "Συμπεριλαμβανομένης σήμερας",
  "importedTask": "Εισαγόμενη εργασία",
  "busyOnAnotherTeam": "Απασχολημένος σε άλλη ομάδα",
  "includeDoneSamples": "Συμπερίληψη ολοκληρωμένων δειγμάτων",
  "includeOverdue": "Συμπερίληψη Εκπρόθεσμων",
  "includeToday": "Συμπερίληψη Σήμερα",
  "iapIncludeTodayWarningIAP": "Προειδοποίηση IAP και Συμπερίληψη Σήμερα — εργασίες που προγραμματίστηκαν νωρίτερα σήμερα μπορούν επίσης να μετακινηθούν εκτός αν είναι κλειδωμένες!",
  "iapIncludeTodayWarningFillIn": "Προειδοποίηση Συμπλήρωσης και Συμπερίληψη Σήμερα — εργασίες που προγραμματίστηκαν νωρίτερα σήμερα μπορούν επίσης να λάβουν νέα κατανεμημένα δείγματα!",
  "initials": "Αρχικά",
  "inputLastMonth": "Εισροή Προηγούμενου Μήνα",
  "inputThisMonth": "Εισροή Τρέχοντος Μήνα",
  "instrument": "Όργανο",
  "instrumentConstraints": "Περιορισμοί Οργάνου",
  "instrumentLog": "Αρχείο Καταγραφής Οργάνου",
  "instrumentName": "Όνομα Οργάνου",
  "instrumentOffset": "Μετατόπιση οργάνου (ΩΩ:ΛΛ)",
  "instrumentOverbooking": "Υπέρ-κράτηση Οργάνου",
  "instrumentPerSampleDuration": "Διάρκεια οργάνου ανά δείγμα (ΩΩ:ΛΛ:ΔΔ)",
  "instrumentSetup": "Ρύθμιση Οργάνου {{name}}",
  "instrumentSetuptime": "Χρόνος ρύθμισης οργάνου (ΩΩ:ΛΛ)",
  "instrumentTime": "Χρόνος Οργάνου",
  "instrumentView": "Προβολή Οργάνου",
  "instruments": "Όργανα",
  "instrumentsWithExpiredMaintenance": "Υπάρχουν όργανα με ληγμένη συντήρηση",
  "instrumentsWithMaintenanceReminders": "Υπάρχουν όργανα με υπενθυμίσεις συντήρησης",
  "integration": "Ενσωμάτωση",
  "invalidDate": "Μη Έγκυρη Ημερομηνία",
  "invalidOutlookLink": "Μη έγκυρος σύνδεσμος iCalendar / Outlook",
  "isInSimulationMode": "Ο {{initials}} βρίσκεται σε λειτουργία προσομοίωσης",
  "isSimulating": "Ο {{initials}} προσομοιώνει...",
  "keepExistingConnections": "Διατήρηση υπαρχουσών συνδέσεων",
  "labelAlreadyLoaded": "Ήδη φορτωμένο: {{count}}",
  "labelCreated": "Δημιουργήθηκε: {{count}}",
  "labelDeleted": "Διαγράφηκε: {{count}}",
  "labelDeletedOrFinished": "Διαγράφηκε ή επισημάνθηκε ως ολοκληρωμένο: {{count}}",
  "labelDoneDeleted": "Ολοκληρώθηκε/Διαγράφηκε: {{count}}",
  "labelUpdatedInformation": "Ενημερώθηκαν πληροφορίες: {{count}}",
  "lastErrorLog": "Τελευταίο Αρχείο Σφαλμάτων",
  "lastWeek": "Προηγούμενη Εβδομάδα",
  "latestArrival": "Τελευταία Άφιξη",
  "leadTimesInWorkDays": "Χρόνοι Παράδοσης σε Εργάσιμες Ημέρες",
  "leaveEmptyIfNotUsed": "(αφήστε κενό αν δεν χρησιμοποιείται)",
  "leaveEmptyIfNotUsedDefault": "(αφήστε κενό αν δεν χρησιμοποιείται, προεπιλογή={{defaultValue}})",
  "loadFromTemplate": "Φόρτωση από πρότυπο",
  "loading": "ΦΟΡΤΩΣΗ",
  "loadingEllipsis": "Φόρτωση...",
  "loadingSamples": "Φόρτωση δειγμάτων",
  "loadingSheet": "Φόρτωση φύλλου",
  "loadingSheets": "Φόρτωση φύλλων",
  "location": "Τοποθεσία",
  "locationColon": "Τοποθεσία: {{name}}",
  "locationName": "Όνομα Τοποθεσίας",
  "lockItemType": "Κλείδωμα {{itemType}}",
  "lockSamples": "Κλείδωμα δειγμάτων",
  "lockUnlockSamplesLabel": "Κλείδωμα/Ξεκλείδωμα δειγμάτων:",
  "locks": "Κλειδώματα",
  "locksAllFutureAnalysisTasks": "Κλειδώνει όλες τις μελλοντικές προγραμματισμένες εργασίες ανάλυσης",
  "locksAllFutureProjectActions": "Κλειδώνει όλες τις μελλοντικές προγραμματισμένες ενέργειες έργου",
  "login": "Σύνδεση",
  "logout": "Αποσύνδεση",
  "maintenanceCreatedSuccessfully": "Η συντήρηση \"{{name}}\" δημιουργήθηκε επιτυχώς",
  "maintenanceDeletedSuccessfully": "Η συντήρηση \"{{name}}\" διαγράφηκε επιτυχώς",
  "maintenanceExpired": "Η συντήρηση έληξε",
  "maintenanceExpiresInDays": "Η συντήρηση λήγει σε λιγότερο από {{days}} ημέρες",
  "maintenanceMarkedAsCompleted": "Η συντήρηση \"{{name}}\" επισημάνθηκε ως ολοκληρωμένη",
  "maintenanceName": "Όνομα συντήρησης",
  "maintenanceUpdatedSuccessfully": "Η συντήρηση \"{{name}}\" ενημερώθηκε επιτυχώς",
  "mandatoryIfRecurrenceUsed": "(υποχρεωτικό αν χρησιμοποιείται επανάληψη)",
  "manualSample": "Χειροκίνητο δείγμα",
  "manualSheetConfiguration": "Χειροκίνητη Διαμόρφωση Φύλλου",
  "markAsDone": "Επισήμανση ως ολοκληρωμένο",
  "maxSampleCount": "Μέγιστος Αριθμός Δειγμάτων",
  "maxSampleCountLabel": "Μέγ. αριθμός δειγμάτων: ",
  "maxTimeBetweenActions": "Μέγιστος χρόνος μεταξύ ενεργειών (ΗΗ:ΩΩ:ΛΛ)",
  "maxTimeBetweenTasks": "Μέγιστος χρόνος μεταξύ εργασιών (ΗΗ:ΩΩ:ΛΛ)",
  "member": "Μέλος",
  "memberHasEnabledICalendarOutlookIntegration": "Το Μέλος Έχει Ενεργοποιήσει την Ενσωμάτωση iCalendar / Outlook",
  "memberHasEnabledOutlook": "Το Μέλος Έχει Ενεργοποιήσει την Ενσωμάτωση iCalendar / Outlook",
  "memberPermissions": "Δικαιώματα μέλους",
  "memberPlan": "Πλάνο Μέλους",
  "memberTime": "Χρόνος Μέλους",
  "membersGoDirectlyToMemberPlan": "Τα μέλη μεταβαίνουν απευθείας στο πλάνο μέλους",
  "message": "Μήνυμα",
  "metric": "Μετρική",
  "minSampleCount": "Ελάχιστος Αριθμός Δειγμάτων",
  "minSampleMustBeLowerThanMax": "Ο ελάχιστος αριθμός δειγμάτων πρέπει να είναι μικρότερος από τον μέγιστο",
  "minTimeBetweenActions": "Ελάχιστος χρόνος μεταξύ ενεργειών (ΗΗ:ΩΩ:ΛΛ)",
  "minTimeBetweenTasks": "Ελάχιστος χρόνος μεταξύ εργασιών (ΗΗ:ΩΩ:ΛΛ)",
  "minTimeMustBeSmallerThanMax": "Ο ελάχιστος χρόνος μεταξύ πρέπει να είναι μικρότερος από τον μέγιστο χρόνο μεταξύ",
  "minimumDuration": "Ελάχιστη Διάρκεια: {{time}}",
  "minute": "λεπτό",
  "missingPasswordRequirements": "Λείπουν απαιτήσεις κωδικού: {{requirements}}",
  "months": "Μήνες",
  "movedBy": "Μετακινήθηκε Από",
  "movedFrom": "Μετακινήθηκε Από",
  "movedTo": "Μετακινήθηκε Σε",
  "mustBeIcsLink": "Πρέπει να είναι σύνδεσμος .ics",
  "name": "Όνομα",
  "namePerformer": "Εκτελεστής {{name}}",
  "nameTooLongTitle": "Το όνομα είναι πολύ μακρύ (μέγιστο 100 χαρακτήρες)",
  "newAnalysisTaskBundle": "Νέο Πακέτο Εργασίας Ανάλυσης",
  "newChat": "Νέα συνομιλία",
  "newInstrument": "Νέο Όργανο",
  "newProject": "Νέο Έργο",
  "newProjectTemplateDraft": "ΠΡΟΣΧΕΔΙΟ Νέου Προτύπου Έργου",
  "newStart": "Νέα Έναρξη",
  "nextDay": "Επόμενη Ημέρα",
  "nextWeek": "Επόμενη Εβδομάδα",
  "no": "Όχι",
  "noAnalysesForProduct": "Δεν βρέθηκαν αναλύσεις για αυτό το προϊόν.",
  "noAssetsFound": "Δεν βρέθηκαν στοιχεία",
  "noChanges": "Καμία αλλαγή",
  "noChatbotSelected": "Δεν επιλέχθηκε chatbot",
  "noDataFound": "Δεν βρέθηκαν δεδομένα",
  "noErrorsToDisplay": "Δεν υπάρχουν σφάλματα για εμφάνιση.",
  "noGroup": "Καμία ομάδα",
  "noMembersLoaded": "Δεν φορτώθηκαν μέλη.",
  "noOfRecurrences": "Αριθ. Επαναλήψεων",
  "noReferencesAvailable": "Δεν υπάρχουν διαθέσιμες αναφορές.",
  "noSamples": "Χωρίς δείγματα",
  "noSamplesAvailable": "Δεν υπάρχουν διαθέσιμα δείγματα",
  "noSearchResults": "Κανένα αποτέλεσμα αναζήτησης",
  "noTimeLimitUnlessSpecified": "Χωρίς χρονικό όριο εκτός αν οριστεί",
  "none": "Κανένα",
  "default": "Προεπιλογή",
  "notAvailable": "Μ/Δ",
  "notEnoughRoomForDuration": "Δεν υπάρχει αρκετός χώρος για τη διάρκεια",
  "notStarted": "Δεν Ξεκίνησε",
  "numberOfObservations": "Αριθμός Παρατηρήσεων",
  "numberOfRecurrences": "Αριθμός επαναλήψεων",
  "numericInputBetweenTimeRange": "Παρακαλώ δώστε αριθμητική τιμή μεταξύ 00:00 και 23:59",
  "offsiteCalendar": "Ημερολόγιο ΕΚΤΟΣ ΕΓΚΑΤΑΣΤΑΣΗΣ",
  "ok": "Εντάξει",
  "oldInstrument": "Παλιό Όργανο",
  "oldStart": "Παλιά Έναρξη",
  "onlyAdvancedUsersInfo": "Μόνο προχωρημένοι χρήστες χρησιμοποιούν τόσο τη νωρίτερη έναρξη όσο και τις συνδέσεις",
  "onsite": "Επί τόπου",
  "openReferences": "Άνοιγμα Αναφορών",
  "operationalGreyTaskTimePercentage": "Ποσοστό χρόνου επιχειρησιακής γκρι εργασίας ως προς τον συνολικό χρόνο (OG2T)",
  "operationalTask": "Επιχειρησιακή Εργασία",
  "otherPlannerSimulating": "Ο {{initials}} βρίσκεται σε λειτουργία προσομοίωσης",
  "outlookLinkLabel": "Σύνδεσμος iCalendar / Outlook",
  "outputLastMonth": "Εκροή Προηγούμενου Μήνα",
  "outputThisMonth": "Εκροή Τρέχοντος Μήνα",
  "parentColumn": "Γονική Στήλη",
  "password": "Κωδικός πρόσβασης",
  "paused": "Σε Παύση",
  "peopleSetup": "Ρύθμιση Ανθρώπινου Δυναμικού",
  "perSampleDuration": "Διάρκεια ανά δείγμα (ΩΩ:ΛΛ:ΔΔ)",
  "perSampleDurationForPeopleSetup": "Διάρκεια Ανά Δείγμα για Ρύθμιση Ανθρώπινου Δυναμικού",
  "performerConstraintsCount": "Αριθμός Περιορισμών Εκτελεστή",
  "performerConstraintsLabel": "Περιορισμοί Εκτελεστή",
  "permanentApiToken": "Μόνιμο Token API",
  "permanentApiTokenDescription": "Αυτό είναι ένα μόνιμο token API που σας επιτρέπει να έχετε πρόσβαση στην ομάδα σας μέσω του API μας. Αντιγράψτε το και αποθηκεύστε το σε ασφαλές μέρος.",
  "pinConversation": "Καρφίτσωμα συνομιλίας",
  "planned": "Προγραμματισμένο",
  "planner": "Προγραμματιστής",
  "plannertechLanguage": "Γλώσσα Plannertech",
  "plannertechVariable": "Μεταβλητή Plannertech",
  "pleaseChooseColor": "Παρακαλώ επιλέξτε Χρώμα για την ανάλυση",
  "pleaseFillOutAnalysisName": "Παρακαλώ συμπληρώστε το Όνομα Ανάλυσης",
  "pleaseFillOutRequiredTaskParams": "Παρακαλώ συμπληρώστε τις απαιτούμενες παραμέτρους εργασίας",
  "pleaseGiveEmptyOrFullInput": "Παρακαλώ δώστε κενή ή πλήρη εισαγωγή",
  "pleaseGiveNumericInput": "Παρακαλώ δώστε αριθμητική εισαγωγή",
  "pleaseInputValidDate": "Παρακαλώ εισάγετε έγκυρη ημερομηνία",
  "pleaseSelectAtLeastOneItem": "Παρακαλώ επιλέξτε τουλάχιστον ένα στοιχείο",
  "pleaseSelectColor": "Παρακαλώ επιλέξτε χρώμα",
  "pleaseSelectFirstDay": "Παρακαλώ επιλέξτε την πρώτη ημέρα.",
  "pleaseSelectLastDay": "Παρακαλώ επιλέξτε την τελευταία ημέρα.",
  "pleaseSelectTimezone": "Παρακαλώ επιλέξτε ζώνη ώρας",
  "previousDay": "Προηγούμενη Ημέρα",
  "primary": "Κύριο",
  "primaryInstrument": "Κύριο Όργανο",
  "prioritizeByDeadline": "Προτεραιοποίηση IAP κατά Προθεσμία",
  "prioritizeByPriority": "Προτεραιοποίηση IAP κατά Αριθμό Προτεραιότητας",
  "priority": "Προτεραιότητα",
  "priorityHigh": "(Υψηλή)",
  "priorityLow": "(Χαμηλή)",
  "priorityMedium": "(Μέτρια)",
  "process": "Διεργασία",
  "processed": "Επεξεργάστηκε",
  "processing": "Επεξεργασία...",
  "processingInProgress": "Επεξεργασία",
  "productName": "Όνομα Προϊόντος",
  "project": "Έργο",
  "projectActions": "ενέργειες έργου",
  "projectBatchNumber": "Αριθμός Παρτίδας Έργου",
  "projectDeadline": "Προθεσμία Έργου",
  "projectDescription": "Περιγραφή Έργου",
  "projectEarliestStart": "Νωρίτερη Έναρξη Έργου",
  "projectGroup": "Ομάδα έργων",
  "projectGroupName": "Όνομα Ομάδας Έργων",
  "projectImport": "Εισαγωγή Έργου",
  "projectImportVariable": "Μεταβλητή Εισαγωγής Έργου",
  "projectMaterialDescription": "Περιγραφή Υλικού Έργου",
  "projectMaterialNumber": "Αριθμός Υλικού Έργου",
  "projectName": "Όνομα Έργου",
  "projectPriority": "Προτεραιότητα Έργου",
  "projectReleaseDate": "Ημερομηνία Κυκλοφορίας Έργου",
  "projectSupplierName": "Όνομα Προμηθευτή Έργου",
  "projectSupplierNumber": "Αριθμός Προμηθευτή Έργου",
  "projectTemplate": "πρότυπο έργου",
  "projectTemplates": "Πρότυπα Έργων",
  "projectTimePercentage": "Ποσοστό χρόνου έργου ως προς τον συνολικό χρόνο (P2T)",
  "projectView": "Προβολή Έργου",
  "projects": "Έργα",
  "projectsAndActions": "Έργα & Ενέργειες",
  "promptPrefix": "Πρόθεμα Prompt",
  "promptTooLongTitle": "Το prompt είναι πολύ μακρύ (μέγιστο 1200 χαρακτήρες)",
  "publish": "ΔΗΜΟΣΙΕΥΣΗ",
  "publishSimulationChanges": "Δημοσίευση αλλαγών λειτουργίας προσομοίωσης",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Επανάληψη",
  "recurEvery": "Επανάληψη κάθε",
  "recurrence": "Επανάληψη",
  "reduce": "Μείωση",
  "references": "Αναφορές",
  "rejectedFileTypes": "Απορριφθέντες Τύποι Αρχείων",
  "rejectedFilesIncompatible": "Τα παρακάτω αρχεία απορρίφθηκαν λόγω ασύμβατων μορφών",
  "reminderDaysBeforeEndDate": "Υπενθύμιση (ημέρες πριν την ημερομηνία λήξης)",
  "remove": "Αφαίρεση",
  "removeAnalysisFromProduct": "Αφαίρεση {{name}} από αυτό το προϊόν",
  "removeAsset": "Αφαίρεση Στοιχείου",
  "removeEverything": "Αφαίρεση όλων",
  "removeInstrument": "Αφαίρεση Οργάνου",
  "reportGenerator": "Γεννήτρια Αναφορών",
  "reports": "Αναφορές",
  "repositories": "Αποθετήρια",
  "repositoryCurrentlyProcessing": "Το αποθετήριο επεξεργάζεται αυτή τη στιγμή τα αρχεία. Παρακαλώ ανανεώστε τη σελίδα για να δείτε την πρόοδο",
  "repositoryHasUnprocessedFiles": "Αυτό το αποθετήριο έχει ανεπεξέργαστα αρχεία",
  "repositoryIsProcessed": "Αυτό το αποθετήριο έχει επεξεργαστεί",
  "repositoryName": "Όνομα Αποθετηρίου",
  "reset": "Επαναφορά",
  "role": "Ρόλος",
  "row": "Γραμμή",
  "rowNumber": " γραμμή {{row}}",
  "runIAP": "Εκτέλεση IAP",
  "runningIAP": "Εκτέλεση IAP",
  "sampleAnalysisName": "Όνομα Ανάλυσης Δείγματος",
  "sampleBatchNumber": "Αριθμός Παρτίδας Δείγματος",
  "sampleHighestPriority": "Το δείγμα έχει την υψηλότερη προτεραιότητα",
  "sampleId": "ID Δείγματος",
  "sampleIdWithValue": "ID Δείγματος: {{id}}",
  "sampleImport": "Εισαγωγή Δείγματος",
  "sampleImportVariable": "Μεταβλητή Εισαγωγής Δείγματος",
  "sampleInProgressOnDoneAnalysis": "Δείγμα σε εξέλιξη σε ολοκληρωμένη ανάλυση",
  "sampleIsDone": "Το δείγμα έχει ολοκληρωθεί",
  "sampleLog": "Αρχείο Καταγραφής Δείγματος",
  "sampleLowestPriority": "Το δείγμα έχει τη χαμηλότερη προτεραιότητα",
  "sampleMaterialNumber": "Αριθμός Υλικού Δείγματος",
  "sampleName": "Όνομα Δείγματος",
  "sampleObservation": "Παρατήρηση Δείγματος",
  "sampleObservations": "Παρατηρήσεις Δείγματος",
  "samplePercentage": "Ποσοστό δείγματος",
  "sampleProductDescription": "Περιγραφή Προϊόντος Δείγματος",
  "sampleReceivedDate": "Ημερομηνία Παραλαβής Δείγματος",
  "sampleStatus": "Κατάσταση Δείγματος",
  "sampleView": "Προβολή Δείγματος",
  "samples": "Δείγματα",
  "samplesWithName": "Δείγματα με το όνομα {{name}}",
  "samplesWithoutProduct": "Δείγματα χωρίς προϊόν",
  "save": "Αποθήκευση",
  "saveAs": "Αποθήκευση Ως",
  "saveAsDraft": "Αποθήκευση ως ΠΡΟΣΧΕΔΙΟ {{type}}",
  "saveAsNew": "Αποθήκευση ως νέο",
  "saveAsNewAnalysis": "Αποθήκευση ως νέα ανάλυση",
  "saveAsNewTemplate": "Αποθήκευση ως νέο πρότυπο",
  "saveAsType": "Αποθήκευση ως {{type}}",
  "scrollToTop": "Μετακίνηση στην κορυφή",
  "scrumView": "Προβολή Scrum",
  "scrumViewOrdering": "Ταξινόμηση Προβολής Scrum",
  "searchBySampleName": "Αναζήτηση κατά όνομα δείγματος...",
  "searchCountry": "Αναζήτηση χώρας",
  "seats": "Θέσεις",
  "second": "δευτερόλεπτο",
  "secondaryInstrumentMustHaveAllowedInstrument": "Η ρύθμιση δευτερεύοντος οργάνου πρέπει να έχει τουλάχιστον ένα επιτρεπόμενο όργανο",
  "selectAll": "Επιλογή Όλων",
  "selectChatbot": "Επιλογή chatbot",
  "selectDefaultChatbot": "Επιλογή προεπιλεγμένου chatbot",
  "selectEntireDay": "Επιλογή ολόκληρης ημέρας",
  "selectEntireWorkday": "Επιλογή ολόκληρης εργάσιμης ημέρας",
  "selectLocation": "Επιλογή τοποθεσίας...",
  "selectSamples": "Επιλογή Δειγμάτων",
  "selectState": "Επιλογή κατάστασης...",
  "selectTimezone": "Επιλογή ζώνης ώρας...",
  "selectType": "Επιλογή Τύπου",
  "selectedFilesReadyForSubmit": "Επιλεγμένα αρχεία/φάκελοι έτοιμα για υποβολή:",
  "selectedProduct": "Επιλεγμένο Προϊόν",
  "setPlannedValues": "Ορισμός Προγραμματισμένων Τιμών",
  "settings": "Ρυθμίσεις",
  "settingsForQcLibrarian": "Ρυθμίσεις για QC Librarian",
  "setupTimeForPeopleSetup": "Χρόνος Ρύθμισης για Ρύθμιση Ανθρώπινου Δυναμικού",
  "setuptime": "Χρόνος ρύθμισης (ΩΩ:ΛΛ)",
  "sheetName": "Όνομα Φύλλου",
  "sheetNameLabel": "Όνομα Φύλλου",
  "sheetType": "Τύπος Φύλλου",
  "shouldBeEqualTo": "πρέπει να ισούται με",
  "shouldNotBeEqualTo": "δεν πρέπει να ισούται με",
  "showAnalyses": "Εμφάνιση Αναλύσεων",
  "showErrors": "Εμφάνιση Σφαλμάτων",
  "showLastErrorLog": "Εμφάνιση τελευταίου αρχείου σφαλμάτων",
  "showLibrarian": "Εμφάνιση Librarian",
  "showLog": "Εμφάνιση Αρχείου Καταγραφής",
  "showMore": "Εμφάνιση περισσότερων",
  "showOnPlan": "Εμφάνιση στο Πλάνο",
  "showProjects": "Εμφάνιση Έργων",
  "shown": "Ορατό",
  "simulationMode": "Λειτουργία Προσομοίωσης",
  "simulationModeLogoutWarning": "Βρίσκεστε αυτή τη στιγμή σε λειτουργία προσομοίωσης. Η αποσύνδεση θα απορρίψει τις αλλαγές!",
  "simulationModeOccupied": "ΛΕΙΤΟΥΡΓΙΑ ΠΡΟΣΟΜΟΙΩΣΗΣ ΚΑΤΕΙΛΗΜΜΕΝΗ",
  "simulationModeUpper": "ΛΕΙΤΟΥΡΓΙΑ ΠΡΟΣΟΜΟΙΩΣΗΣ",
  "somethingWentWrong": "Κάτι πήγε στραβά",
  "sortByProduct": "Ταξινόμηση κατά προϊόν",
  "sortByTime": "Ταξινόμηση Κατά Χρόνο",
  "sortByTimeDescription": "Ταξινομεί τις ενέργειες Εκκρεμοτήτων και Προς Εκτέλεση κατά προθεσμίες τους, και τις Προγραμματισμένες και Ολοκληρωμένες κατά χρόνο έναρξής τους",
  "speechToTextLanguage": "Γλώσσα ομιλίας σε κείμενο",
  "spreadsheetColumnName": "Όνομα Στήλης Υπολογιστικού Φύλλου",
  "stage": "Στάδιο",
  "standardActions": "Τυπικές Ενέργειες",
  "start": "Έναρξη",
  "startDate": "Ημερομηνία Έναρξης",
  "startDateCheckboxInfo": "Όταν είναι επιλεγμένο, η προθεσμία έργου, η προθεσμία ενέργειας και η έναρξη ενέργειας θα μετακινηθούν σχετικά με την έναρξη έργου",
  "startEndDate": "Ημερομηνία Έναρξης/Λήξης",
  "startProcessingInfo": "Αυτό θα ξεκινήσει την επεξεργασία του αποθετηρίου. Μπορεί να πάρει λίγο χρόνο ανάλογα με το μέγεθος του αποθετηρίου",
  "startRecurrence": "Έναρξη Επανάληψης",
  "startTime": "Ώρα Έναρξης",
  "started": "Ξεκίνησε",
  "state": "Κατάσταση",
  "status": "Κατάσταση",
  "submit": "Υποβολή",
  "successfullyLoaded": "Φορτώθηκε επιτυχώς: {{members}}",
  "successfullyUploadedFiles": "Αρχεία Αναρτήθηκαν Επιτυχώς",
  "systemPrompt": "Prompt συστήματος",
  "taskBelongsToTeam": "Η εργασία ανήκει στην ομάδα: {{team}}",
  "taskCount": "Αριθμός Εργασιών",
  "taskDesignTool": "Εργαλείο Σχεδιασμού Εργασιών",
  "taskLog": "Αρχείο Καταγραφής Εργασιών",
  "taskName": "Όνομα Εργασίας",
  "taskPerformerConstraints": "Περιορισμοί Εκτελεστή Εργασίας",
  "tasks": "Εργασίες",
  "team": "Ομάδα",
  "teamChatbot": "Chatbot ομάδας",
  "teamLabel": "Ομάδα: {{name}}",
  "teamMember": "Μέλος Ομάδας",
  "teamName": "Όνομα Ομάδας",
  "teamPlan": "Πλάνο Ομάδας",
  "teamUsageTitle": "Χρήση {{name}}",
  "teams": "Ομάδες",
  "templateIsDraft": "Αυτό το πρότυπο έργου είναι Προσχέδιο",
  "templateName": "Όνομα Προτύπου",
  "theProjectIsDone": "Το έργο έχει ολοκληρωθεί",
  "timeConstraints": "Χρονικοί Περιορισμοί",
  "timeHHMM": "Ώρα (ΩΩ:ΛΛ)",
  "timePeriod": "Χρονική Περίοδος",
  "timestamp": "Χρονική Σήμανση",
  "timezone": "Ζώνη Ώρας",
  "to": "Σε",
  "toConfirmDeletionType": "Για επιβεβαίωση διαγραφής πληκτρολογήστε {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Για επιβεβαίωση διαγραφής πληκτρολογήστε {{keyword}} και πατήστε επιβεβαίωση. Αυτό θα διαγράψει οριστικά τα δεδομένα δοκιμής, ακόμα και με λειτουργία προσομοίωσης. Δεν υπάρχει επιστροφή.",
  "toConfirmDeletionTypeKeyword": "Για επιβεβαίωση διαγραφής πληκτρολογήστε {{keyword}} και πατήστε επιβεβαίωση",
  "toDate": "Έως ημερομηνία",
  "toDo": "Προς Εκτέλεση",
  "toTime": "Έως ώρα (ΩΩ:ΛΛ)",
  "toTimeHH": "Έως ώρα (ΩΩ)",
  "toTimeHHMM": "Έως ώρα (ΩΩ:ΛΛ)",
  "today": "Σήμερα",
  "tokens": "Tokens",
  "total": "Σύνολο",
  "normalSeats": "Κανονικές",
  "tryReloadingOrContactSupport": "Δοκιμάστε να ανανεώσετε, ή επικοινωνήστε με την υποστήριξη αν το πρόβλημα επιμένει!",
  "type": "Τύπος",
  "typeBeforeConfirming": "πληκτρολογήστε {{keyword}} πριν επιβεβαιώσετε",
  "typeOrSelect": "Πληκτρολογήστε ή επιλέξτε...",
  "typeYourMessage": "Πληκτρολογήστε το μήνυμά σας...",
  "unassignedSamples": "Μη ανατεθειμένα δείγματα",
  "unassignedSamplesFor": "Μη ανατεθειμένα δείγματα για \"{{name}}\"",
  "unflag": "Κατάργηση επισήμανσης",
  "unflagSample": "Κατάργηση Επισήμανσης Δείγματος",
  "unlockItemType": "Ξεκλείδωμα {{itemType}}",
  "unlockSamples": "Ξεκλείδωμα δειγμάτων",
  "unlocks": "Ξεκλειδώματα",
  "unlocksAllFutureAnalysisTasks": "Ξεκλειδώνει όλες τις μελλοντικές προγραμματισμένες εργασίες ανάλυσης",
  "unlocksAllFutureProjectActions": "Ξεκλειδώνει όλες τις μελλοντικές προγραμματισμένες ενέργειες έργου",
  "unnamed": "χωρίς όνομα",
  "unpinConversation": "Απο-καρφίτσωμα συνομιλίας",
  "unplan": "Αποπρογραμματισμός",
  "unplanAnalysis": "Αποπρογραμματισμός Ανάλυσης",
  "unplanItemType": "Αποπρογραμματισμός {{itemType}}",
  "unplanSample": "Αποπρογραμματισμός Δείγματος",
  "unplanSelected": "Αποπρογραμματισμός Επιλεγμένων",
  "unplanned": "Μη Προγραμματισμένο",
  "unplannedProjects": "Μη Προγραμματισμένα Έργα",
  "unsavedChangesIn": "Υπάρχουν μη αποθηκευμένες αλλαγές σε:",
  "updateIntegration": "Ενημέρωση Ενσωμάτωσης",
  "updatedIcalOutlook": "Το iCalendar / Outlook ενημερώθηκε!",
  "uploadAborted": "Η ανάρτηση ακυρώθηκε!",
  "uploadComplete": "Η ανάρτηση ολοκληρώθηκε!",
  "uploadFailedForFile": "Η ανάρτηση απέτυχε για το αρχείο: {{path}}",
  "uploadFinished": "Η Ανάρτηση Ολοκληρώθηκε!",
  "uploadTo": "Ανάρτηση σε {{name}}",
  "usage": "Χρήση",
  "used": "Χρησιμοποιήθηκε",
  "usedAssets": "Χρησιμοποιούμενα Στοιχεία",
  "usedInstrument": "Χρησιμοποιούμενο Όργανο",
  "usedInstruments": "Χρησιμοποιούμενα Όργανα",
  "username": "Όνομα χρήστη",
  "value": "Τιμή",
  "view": "Προβολή",
  "viewAllAnalysesForProduct": "Προβολή όλων των αναλύσεων για αυτό το προϊόν",
  "viewAnalysisSamples": "Προβολή Δειγμάτων Ανάλυσης",
  "viewCompact": "Συμπαγής Προβολή",
  "viewNormal": "Κανονική Προβολή",
  "weekNumber": "Εβδομάδα {{week}}",
  "weekView": "Εβδομαδιαία Προβολή",
  "dayView": "Ημερήσια Προβολή",
  "weekendView": "Προβολή Σαββατοκύριακου",
  "screen": "Οθόνη",
  "clickToSortBy": "Κλικ για ταξινόμηση κατά {{column}}",
  "fileChangedPleaseReselect": "Το {{file}} άλλαξε. Παρακαλώ επιλέξτε ξανά το αρχείο",
  "contentTooWideZoomOut": "Το περιεχόμενο είναι πολύ πλατύ για την οθόνη. Για καλύτερη εμπειρία προβολής, σμικρύνετε ({{key}} +/-)",
  "week": "Εβδομάδα",
  "weekly": "Εβδομαδιαίο",
  "weeks": "εβδομάδα(ες)",
  "withConnections": "με συνδέσεις",
  "workHours": "Ώρες Εργασίας",
  "workWeek": "Εργάσιμη Εβδομάδα",
  "years": "Χρόνια",
  "yes": "Ναι",
  "youAreInSimulationMode": "Βρίσκεστε σε λειτουργία προσομοίωσης",
  "zeroHours": "0 ώρες",
  "addCustomer": "Προσθήκη πελάτη",
  "addGlobalChatbot": "Προσθήκη καθολικού chatbot",
  "addGlobalRepository": "Προσθήκη καθολικού αποθετηρίου",
  "apiKey": "Κλειδί API",
  "authenticationCode": "Κωδικός Ταυτοποίησης",
  "authenticationCodeSentInfo": "Έχουμε στείλει έναν κωδικό ταυτοποίησης στο email σας. Παρακαλώ εισάγετέ τον παραπάνω πριν συνδεθείτε",
  "chatbotPrefix": "Πρόθεμα chatbot",
  "chatbotSystemPrompt": "Prompt Συστήματος Chatbot",
  "chatbotSystemPrompts": "Prompts Συστήματος Chatbot",
  "citationGuidelines": "Οδηγίες παραπομπών",
  "configureMember": "Διαμόρφωση Μέλους",
  "createApiKey": "Δημιουργία κλειδιού API",
  "creatingProject": "Δημιουργία Έργου",
  "currentQuestion": "Τρέχουσα ερώτηση",
  "customerAdminApiKeyForGlobalRepositories": "Κλειδί API Διαχειριστή Πελάτη για Καθολικά Αποθετήρια",
  "dateFormatYyyyMmDd": "ΕΕΕΕ-ΜΜ-ΗΗ",
  "deleteApiKey": "Διαγραφή κλειδιού API",
  "descriptionPrompt": "Prompt Περιγραφής",
  "editGlobalMessage": "Επεξεργασία Καθολικού Μηνύματος",
  "editingProject": "Επεξεργασία Έργου",
  "editSystemPrompts": "Επεξεργασία Prompts Συστήματος",
  "filePathPrompt": "Prompt Διαδρομής Αρχείου",
  "fillingInSamples": "Συμπλήρωση δειγμάτων",
  "generalPrefix": "Γενικό πρόθεμα",
  "globalChatbots": "Καθολικά Chatbots",
  "globalRepositories": "Καθολικά Αποθετήρια",
  "hideNextWeek": "Απόκρυψη Επόμενης Εβδομάδας",
  "hideSatSun": "- Σαβ/Κυρ",
  "manageAdmins": "Διαχείριση Διαχειριστών",
  "oneWeek": "1 Εβδομάδα",
  "openMetricsPanel": "Άνοιγμα Πλαισίου Μετρικών/IAP",
  "openTodoList": "Άνοιγμα Λίστας Εργασιών",
  "optimizedQuestionPrompt": "Βελτιστοποιημένο prompt ερώτησης",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Πλάνο Ομάδας Plannertech",
  "previousConversation": "Προηγούμενη συνομιλία",
  "librarianLogoAlt": "Λογότυπο Librarian",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Σχετική τεκμηρίωση",
  "repositoryHasUnprocessedFilesInfo": "Υπάρχουν ανεπεξέργαστα αρχεία σε αυτό το αποθετήριο",
  "repositoryIsEmpty": "Αυτό το αποθετήριο είναι κενό",
  "repositoryPrefix": "Πρόθεμα αποθετηρίου",
  "repositoryProcessingInProgressInfo": "Το αποθετήριο επεξεργάζεται αυτή τη στιγμή τα αρχεία. Παρακαλώ ανανεώστε τη σελίδα για να δείτε την πρόοδο",
  "sampleAllocation": "Κατανομή δειγμάτων",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Θέσεις: {{count}}",
  "excludingToday": "Εξαιρουμένης σήμερας",
  "unplanning": "Αποπρογραμματισμός",
  "activeSeats": "Ενεργές θέσεις: {{count}}",
  "totalSeats": "Κανονικές θέσεις: {{count}}",
  "purchasedSeats": "Αγορασμένες θέσεις: {{count}}",
  "globalMessage": "Καθολικό Μήνυμα",
  "clearGlobalMessageConfirm": "Είστε σίγουροι ότι θέλετε να εκκαθαρίσετε το καθολικό μήνυμα; Αυτό θα το κάνει να εξαφανιστεί για όλους τους χρήστες.",
  "samplesCount": "Δείγματα: {{count}}",
  "locations": "Τοποθεσίες",
  "customers": "Πελάτες",
  "editCustomer": "Επεξεργασία πελάτη",
  "addCustomerTitle": "Προσθήκη Πελάτη",
  "deleteCustomer": "Διαγραφή Πελάτη",
  "customerName": "Όνομα Πελάτη",
  "customerStatus": "Κατάσταση πελάτη",
  "active": "Ενεργός",
  "passive": "Παθητικός",
  "allowedDomains": "Επιτρεπόμενοι Τομείς",
  "allowedPerformers": "Επιτρεπόμενοι εκτελεστές",
  "seatsPurchased": "Αγορασμένες θέσεις",
  "customerApiKey": "Κλειδί API πελάτη",
  "durationFormatDDHH": "ΗΗ:ΩΩ",
  "durationFormatHHMMSS": "ΩΩ:ΛΛ:ΔΔ",
  "durationFormatHHMM": "ΩΩ:ΛΛ",
  "durationFormatHH": "ΩΩ",
  "durationFormatDDHHMM": "ΗΗ:ΩΩ:ΛΛ",
  "continue": "Συνέχεια",
  "showNextWeek": "Εμφάνιση Επόμενης Εβδομάδας",
  "showSatSun": "+ Σαβ/Κυρ",
  "topDescriptionPrompt": "Prompt κορυφαίας περιγραφής",
  "twoWeeks": "2 Εβδομάδες",
  "updateHelpPage": "Ενημέρωση Σελίδας Βοήθειας",
  "userAlreadyLoggedInTakeOver": "Ο χρήστης είναι ήδη συνδεδεμένος. Για να αναλάβετε τη συνεδρία πατήστε επιβεβαίωση",
  "zoomIn": "Μεγέθυνση",
  "zoomOut": "Σμίκρυνση",
  "constraintWarningTitle": "Προέκυψαν {{count}} προειδοποίηση(ες)",
  "assetStatusFree": "Ελεύθερο",
  "assetStatusBooked": "Δεσμευμένο",
  "dateTo": "έως",
  "futureAnalysisTaskCantBeFinished": "Μια μελλοντική εργασία ανάλυσης δεν μπορεί να ολοκληρωθεί",
  "tableNotFound": "Ο πίνακας δεν βρέθηκε",
  "conversionSheetFilename": "Φύλλο Μετατροπής.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Διαχειριστής",
  "customerAdmin": "Διαχειριστής Πελάτη",
  "attachFile": "Επισύναψη αρχείου",
  "removeFile": "Αφαίρεση αρχείου",
  "fileTooLarge": "Το αρχείο είναι πολύ μεγάλο (μέγ. 10 MB)",
  "tooManyFiles": "Μέγιστο 3 αρχεία ανά μήνυμα",
  "unsupportedFileType": "Μη υποστηριζόμενος τύπος αρχείου. Επιτρεπόμενοι: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
